export const ExtensionAuthErrors = {
  NO_EXTENSION_ID: 'No extension ID provided. Please try connecting from the extension.',
  INVALID_EXTENSION_ID: 'Invalid extension ID. Please ensure you are using the correct version of the extension.',
  NO_SESSION: 'No active session found. Please try logging in again.',
  NO_EXTENSION: 'Chrome extension not found. Please ensure the extension is installed.',
  UNKNOWN: 'An unexpected error occurred. Please try again.',
  TIMEOUT: 'Connection to extension timed out. Please try again.',
} as const; 